import React from "react";
import Tippy from "@tippyjs/react";

interface TooltipProps {
  text: string;
  position?:
    | "top"
    | "right"
    | "bottom"
    | "left"
    | "top-right"
    | "top-left"
    | "bottom-left"
    | "bottom-right";
  children?: React.ReactNode;
  delay?: number;
  disabled?: boolean;
  asChild?: boolean;
}

const positionMap: Record<string, any> = {
  top: "top",
  right: "right",
  bottom: "bottom",
  left: "left",
  "top-right": "top-end",
  "top-left": "top-start",
  "bottom-right": "bottom-end",
  "bottom-left": "bottom-start",
};

const Tooltip: React.FC<TooltipProps> = ({
  text,
  position = "top",
  children,
  delay = 500,
  disabled = false,
  asChild = false,
}) => {
  const trigger =
    asChild && React.isValidElement(children) ? children : undefined;

  if (trigger) {
    return (
      <Tippy
        content={text}
        placement={positionMap[position]}
        delay={[delay, 0]}
        appendTo={document.body}
        zIndex={999999}
        disabled={disabled}
      >
        {trigger}
      </Tippy>
    );
  }

  return (
    <Tippy
      content={text}
      placement={positionMap[position]}
      delay={[delay, 0]}
      appendTo={document.body}
      zIndex={999999}
      disabled={disabled}
    >
      <span style={{ display: "inline-flex" }}>
        {children ? children : <span className="info-icon">ℹ</span>}
      </span>
    </Tippy>
  );
};

export default Tooltip;
